import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	issueSelectPlaceholder: {
		id: 'polaris-common.creatable-idea-select.issue-select-placeholder',
		defaultMessage: 'Start typing to search for or create an idea',
		description: 'Placeholder text in issue select component.',
	},
});
